





































import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import CompaniesActions from './CompaniesActions.vue';
import { ID } from '../../core/utils';
@Component({
    components: {
        Loading,
        Button,
        SimpleTable,
        SectionTitle,
        CompaniesActions
    }
})
export default class ModalVehicleActions extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ default: false }) visible: boolean;
    @Prop({
        default() {
            return [];
        }
    })
    selectedCompanies: Array<object>;
    activationVehicleStatus: number | null = null;
    activationVehicleStatusMsg: string = '';
    modalTitle: string = 'Acciones múltiples';
    subtitle: string = 'Estas acciones serán aplicadas sobre las empresas seleccionadas'
    pendingRequest: boolean = false;
   

    @Emit()
    updateCompaniesDebt(companiesIds: ID[], newDebtValue: boolean) {}

    @Emit()
    updateSuspendServices(companiesIds: ID[], newSuspendedValue: boolean) {}

    submit() {
        
    }

    @Emit()
    closeModal() {
       
    }

    mounted() {
        this.$nextTick(() => {
           
        });
    }
}
